<template>
    <div>
        <div v-for="item in input_keys" :key="`project-input-keys-${item.id}`">
            <div class="pt-3 pb-1 d-flex">
                <span v-if="item.is_required">*</span>
                {{ label(item) }}
                <ProjectInputDescriptionPopOver v-if="item.description && !use_criteria_box" 
                                                :input_key="item"
                                                :label="label(item)"
                />
            </div>
            <b-form-input v-if="item.value_type === 'int'"
                          v-model.number="form[item.key_name]"
                          type="number"
                          :placeholder="label(item)"
                          number
                          :disabled="loading"
            />
            <b-form-input v-else-if="item.value_type === 'str'"
                          v-model.trim="form[item.key_name]"
                          :placeholder="label(item)"
                          :disabled="loading"
            />
            <b-form-select v-else-if="item.value_type === 'list'"
                           v-model="form[item.key_name]"
                           :disabled="loading"
            >
                <b-form-select-option :value="null" disabled>
                    {{ label(item) }} {{ $t('선택') }}
                </b-form-select-option>
                <b-form-select-option v-for="(value, index) in item.allowed_values"
                                      :key="`${value.label_key}-${index}`" :value="value.actual_value">
                    {{ value?.[`label_${$i18n.locale}`] }}
                </b-form-select-option>
            </b-form-select>

            <!-- 기준 상시 노출 (criteriaBox 테넌트): description 있는 입력 아래에 항상 표시 -->
            <div v-if="use_criteria_box && descHtml(item)"
                 class="input-criteria-box mt-2"
                 v-html="descHtml(item)"
            />
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import ProjectInputDescriptionPopOver
from '@/components/auth/Register/_SubComponents/RegisterStep2/ProjectInputDescriptionPopOver.vue';
import {inputKeyDescriptionHtml}
from '@/components/auth/Register/_SubComponents/RegisterStep2/inputKeyDescription';
import {tenant, mergeTenantRegister} from '@shared/utils/tenant';

export default {
    name: 'ProjectInputForm',
    components: {ProjectInputDescriptionPopOver},
    model: {
        prop: 'form',
        event: 'changeForm',
    },
    props: {
        input_keys: {
            type: Array,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        label() {
            return (item) => {
                return item.label_texts?.[this.$i18n.locale] || item.label_texts?.ko;
            };
        },
        use_criteria_box() {
            const merged = mergeTenantRegister(tenant && tenant.register, this.$store.state.register.remote_register_config);
            return !!(merged && merged.criteriaBox);
        },
    },
    methods: {
        descHtml(item) {
            return inputKeyDescriptionHtml(item, this.$i18n.locale);
        },
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit('changeForm', this.form);
            }
        }
    },
};
</script>

<style lang="scss" scoped>

.input-criteria-box {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 0.85rem;
    line-height: 1.6;
    color: #495057;
}
</style>
